import { createIsMatchRegex } from '~teacher/util/regexHelpers/createIsMatchRegex';

export const isEmailShowbie = createIsMatchRegex(/@showbie.com/);
